<template>
  <div class="col-span-full gap-4">
    <InsuranceForm
      :loading="formLoading"
      :quota="quota"
      @tableData="updateTable($event)"
    />

    <customDialog
      v-if="transactionListDialog"
      :title="$t('TRANSACTION_LIST')"
      childClass="info_msg"
      customWidth="70%"
      :show="transactionListDialog"
      :showClose="true"
      :showFooter="false"
      @show="transactionListDialog = $event"
    >
      <el-table
        :empty-text="$t('NO_DATA')"
        :data="
          transactionList.filter(
            (data) => !search || data.amount.includes(search)
          )
        "
        v-loading="transactionTableLoading"
        :stripe="true"
        :default-sort="{ prop: 'id', order: 'descending' }"
        style="width: 100%"
        max-height="400"
      >
        <el-table-column
          sortable
          type="index"
          :align="$i18n.locale == 'fa' ? 'right' : 'left'"
          :label="$t('INDEX')"
          width="60"
        >
          <template slot-scope="scope">
            <div :data-title="$t('INDEX')">
              {{ scope.$index + 1 }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          :align="$i18n.locale == 'fa' ? 'right' : 'left'"
          :label="$t('DATE_')"
          width="120"
        >
          <template slot-scope="scope">
            <div :data-title="$t('DATE_')">
              {{ scope.row.date | getPersianDate }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          :align="$i18n.locale == 'fa' ? 'right' : 'left'"
          :label="$t('NUMBER_OF_TRANSACTION')"
          width="120"
        >
          <template slot-scope="scope">
            <div :data-title="$t('EXPIRED_DATE')">
              {{ scope.row.number }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          :align="$i18n.locale == 'fa' ? 'right' : 'left'"
          :label="$t('TYPE')"
          width="120"
        >
          <template slot-scope="scope">
            <div :data-title="$t('TYPE')">
              {{ typeList.find((i) => i.id === scope.row.type).title }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="" width="100">
          <template slot-scope="scope">
            <div class="fixed-column">
              <tableFeatures
                :description="scope.row.description"
                @remove="removeTransaction(scope.row.id)"
                @open="open($event)"
                :title="$t('TRANSACTION')"
                :view="false"
                :Editable="false"
              >
              </tableFeatures>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </customDialog>

    <customDialog
      customWidth="60%"
      v-if="transactionDialog"
      :title="$t('ADD_TRANSACTION')"
      childClass="info_msg"
      :show="transactionDialog"
      @show="transactionDialog = $event"
      @confirmButn="submitTrans"
      form="true"
    >
      <el-form
        status-icon
        :model="transaction"
        label-position="top"
        ref="transaction"
        label-width="120px"
        class="demo-ruleForm grid lg:grid-cols-3 gap-4 status-icon"
      >
        <el-form-item
          :label="$t('DATE_')"
          prop="date"
          :rules="{
            required: true,
            message: $t('REQUIRED_FIELD', {
              type: $t('DATE_'),
            }),
            trigger: 'blur',
          }"
        >
          <date-picker
            color="#151515"
            class="el-input__inner"
            v-model="transaction.date"
            format="jYYYY-jMM-jDD"
            clearable
            :locale="$i18n.locale"
          />
        </el-form-item>

        <el-form-item
          :rules="{
            required: true,
            message: $t('REQUIRED_FIELD', {
              type: $t('NUMBER_OF_TRANSACTION'),
            }),
            trigger: 'blur',
          }"
          :label="$t('NUMBER_OF_TRANSACTION')"
          prop="number"
        >
          <el-input
            type="text"
            @input="transaction.number = toEnglish(transaction.number)"
            v-model="transaction.number"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item
          :rules="{
            required: true,
            message: $t('REQUIRED_CHOOSE', {
              type: $t('TYPE'),
            }),
            trigger: 'change',
          }"
          :label="$t('TYPE')"
          prop="type"
        >
          <el-select
            :placeholder="$t('SELECT_PLACEHOLDER')"
            v-model="transaction.type"
          >
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          class="col-span-full mt-8"
          :label="$t('description')"
          prop="description"
        >
          <el-input
            type="textarea"
            v-model="transaction.description"
          ></el-input>
        </el-form-item>

        <template v-slot:footerConfirm>
          <el-button type="success" @click="submitForm('transaction')">
            {{ $t('SUBMIT') }}
          </el-button>
        </template>
      </el-form>
    </customDialog>
    <Content
      class="col-span-full"
      title="INSURANCE_INFO_LIST"
      :showBreadcrumb="false"
      :showAdd="false"
    >
      <el-table
        :empty-text="$t('NO_DATA')"
        :data="
          tableData.filter((data) => !search || data.amount.includes(search))
        "
        v-loading="tableLoading"
        :stripe="true"
        :default-sort="{ prop: 'id', order: 'descending' }"
        style="width: 100%"
        max-height="400"
      >
        <el-table-column
          sortable
          type="index"
          :align="$i18n.locale == 'fa' ? 'right' : 'left'"
          :label="$t('INDEX')"
          width="60"
        >
          <template slot-scope="scope">
            <div :data-title="$t('INDEX')">
              {{ scope.$index + 1 }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          :align="$i18n.locale == 'fa' ? 'right' : 'left'"
          prop="insurance_id"
          :label="$t('TYPE')"
          width="120"
        >
          <template slot-scope="scope">
            <div :data-title="$t('TYPE')">
              {{
                $i18n.locale == 'fa'
                  ? scope.row.type.fa_title
                  : scope.row.type.en_title
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          :align="$i18n.locale == 'fa' ? 'right' : 'left'"
          prop="insurance_id"
          :label="$t('INSURANCE_ID')"
          width="120"
        >
          <template slot-scope="scope">
            <div :data-title="$t('INSURANCE_ID')">
              {{ scope.row.insurance_id }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :align="$i18n.locale == 'fa' ? 'right' : 'left'"
          :label="$t('ISSUED_DATE')"
          width="120"
        >
          <template slot-scope="scope">
            <div :data-title="$t('ISSUED_DATE')">
              {{ scope.row.issued_date | getPersianDate }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          :align="$i18n.locale == 'fa' ? 'right' : 'left'"
          :label="$t('EXPIRED_DATE')"
          width="120"
        >
          <template slot-scope="scope">
            <div :data-title="$t('EXPIRED_DATE')">
              {{ scope.row.expiration_date | getPersianDate }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          :align="$i18n.locale == 'fa' ? 'right' : 'left'"
          :label="$t('USED_QUOATA')"
          width="150"
        >
          <template slot-scope="scope">
            <div :data-title="$t('USED_QUOATA')">
              {{ scope.row.quota_capacity_during_add }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          :align="$i18n.locale == 'fa' ? 'right' : 'left'"
          :label="$t('REMAIN_CAPACITY')"
          width="120"
        >
          <template slot-scope="scope">
            <div :data-title="$t('REMAIN_CAPACITY')">
              {{ scope.row.remaining_quota_capacity }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="" width="150">
          <template slot-scope="scope">
            <div class="fixed-column">
              <tableFeatures
                :description="scope.row.description"
                @remove="remove(scope.row.id)"
                :title="$t('INSURANCE_INFO')"
                @open="open($event)"
                :view="false"
                :editLink="false"
                @edit="edit(scope.row.id)"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('ADD_TRANSACTION')"
                  placement="bottom"
                >
                  <i
                    @click="
                      transactionDialog = true
                      selected = scope.row.id
                    "
                    class="el-icon-plus text-lg cursor-pointer text-green-700"
                  ></i>
                </el-tooltip>

                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('TRANSACTION_LIST')"
                  placement="bottom"
                >
                  <i
                    @click="openTransactionList(scope.row.id)"
                    class="el-icon-s-order text-lg cursor-pointer text-blue-500"
                  ></i>
                </el-tooltip>
              </tableFeatures>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        v-if="total_pages > 1"
        parameter="and"
        :pagination="{
          count: tableData.count,
          current: +$route.query.p,
          request: `insurances/company-vehicles/?company_vehicle=${
            tableData.length > 0 ? tableData[0].company_vehicle.id : ''
          }`,
        }"
        @tableData="tableData = $event"
        @loading="updatingLoading = $event"
      />
    </Content>
  </div>
</template>
<script>
import InsuranceForm from './InsuranceForm.vue'
import Pagination from '@/components/elements/pagination'
import {
  getInsuranceNew,
  getAInsuranceNew,
  removeInsurance,
  addInsuranceTransaction,
  getInsuranceTransaction,
  removeInsuranceTransaction,
} from '@/api/cars'
import tableFeatures from '@/components/elements/tableFeatures'
import { open } from '@/mixins/openDesc'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import { numberWithSpaces } from '@/mixins/numberWithSpaces'
import customDialog from '@/components/elements/dialog'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import { resetForm } from '@/mixins/resetForm'

export default {
  mixins: [
    open,
    numberWithSpaces,
    gregorianToJalali,
    jalaliToGregorian,
    resetForm,
  ],
  components: {
    InsuranceForm,
    tableFeatures,
    Pagination,
    customDialog,
  },
  data() {
    return {
      tableData: [],
      search: '',
      tableLoading: true,
      quota: null,
      formLoading: false,
      total_pages: 0,
      transactionDialog: false,
      transactionListDialog: false,
      transactionTableLoading: false,
      transactionList: null,
      selected: null,
      transaction: {
        date: '',
        type: true,
        description: '',
        number: '',
      },
      typeList: [
        {
          title: 'تصادف',
          id: false,
        },
        {
          id: true,
          title: 'دریافت کوپن جدید',
        },
      ],
    }
  },

  mounted() {
    getInsuranceNew.api(this.$route.params.id).then((res) => {
      this.tableLoading = false
      if (res) {
        this.tableData = res.results
        this.total_pages = res.total_pages
      }
    })
  },
  methods: {
    remove(id) {
      removeInsurance.api(id).then((res) => {
        if (res) {
          this.$notify({
            title: this.$i18n.t('SOMETHING_DELETED', {
              type: this.$i18n.t('INSURANCE_INFO'),
            }),
            duration: 4000,
            customClass: 'info_msg',
          })
          this.tableData = this.tableData.filter((table) => table.id !== id)
        }
      })
    },
    removeTransaction(id) {
      removeInsuranceTransaction.api(id).then((res) => {
        if (res) {
          this.$notify({
            title: this.$i18n.t('SOMETHING_DELETED', {
              type: this.$i18n.t('TRANSACTION'),
            }),
            duration: 4000,
            customClass: 'info_msg',
          })
          this.transactionList = this.transactionList.filter(
            (table) => table.id !== id
          )
        }
      })
    },

    edit(id) {
      this.formLoading = true
      this.tableLoading = true
      getAInsuranceNew.api(id).then((res) => {
        this.formLoading = false
        this.tableLoading = false
        if (res) {
          this.quota = res
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      })
    },
    updateTable(data) {
      this.quota = null
      console.log(data)
      if (data.mode == 'add') {
        this.tableData.push({
          insurance_id: data.insurance_id,
          issued_date: data.issued_date,
          expiration_date: data.expiration_date,
          type: data.type,
          remaining_quota_capacity: data.remaining_quota_capacity,
          quota_capacity_during_add: data.quota_capacity_during_add,
          id: data.id,
        })
      } else {
        var updateRow = this.tableData.findIndex((x) => x.id == data.id)
        this.tableData.push({
          amount: '',
          date: '',
          insurance_id: '',
          issued_date: '',
          expiration_date: '',
          type: '',
          remaining_quota_capacity: '',
          quota_capacity_during_add: '',
        })
        this.tableData.pop()
        this.tableData[updateRow] = data
      }
    },
    submitTrans() {
      this.$refs['transaction'].validate((valid) => {
        if (valid) {
          const actionPayload = {
            company_vehicle_insurance: this.selected,
            date: this.jalaliToGregorian(
              this.transaction.date,
              this.$i18n.locale
            ),
            type: this.transaction.type,
            number: this.transaction.number,
            description: this.transaction.description,
          }

          addInsuranceTransaction.api(actionPayload).then((res) => {
            if (res) {
              this.$notify.success({
                title:
                  this.$t('ADD_TRANSACTION') +
                  ' ' +
                  this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })

              this.transactionDialog = false
              this.resetForm('transaction')
            } else {
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t('ADD_TRANSACTION'),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
    openTransactionList(id) {
      getInsuranceTransaction.api(id).then((res) => {
        this.tableLoading = false
        if (res) {
          this.transactionList = res.results
          this.transactionListDialog = true
        }
      })
    },
  },
}
</script>
